module.exports = __webpack_public_path__ + "logo-simquadrat.svg?086c45b7a2fb9f37209845c6bcd76b91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-simquadrat.svg
// module id = 103
// module chunks = 0